import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedBarChart } from '../visualizations/AnimatedBarChart';
export function Slide18CapitalUse() {
  const allocation = [{
    label: 'Product Development (App & MVP)',
    value: 40,
    displayValue: '40%'
  }, {
    label: 'Sales & Brand Onboarding',
    value: 25,
    displayValue: '25%'
  }, {
    label: 'Redeem Network Expansion',
    value: 20,
    displayValue: '20%'
  }, {
    label: 'Marketing & PR',
    value: 15,
    displayValue: '15%'
  }];
  return <div className="flex flex-col h-full justify-center max-w-5xl mx-auto w-full" data-id="element-219">
      <motion.h2 className="text-5xl font-bold text-white mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-220">
        Capital Use
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-221">
        <div className="bg-white/5 p-8 rounded-2xl border border-white/10" data-id="element-222">
          <AnimatedBarChart data={allocation} maxValue={100} data-id="element-223" />
        </div>

        <div className="space-y-6" data-id="element-224">
          <h3 className="text-2xl font-bold text-[#ffd700]" data-id="element-225">Key Milestones</h3>
          {['Develop Finns i Sjön MVP → full app', 'Scale redeem network to 50+ partners', 'Automate SponsrAI matching engine', 'Build dedicated Co-Brand sales team'].map((milestone, i) => <motion.div key={i} initial={{
          x: 20,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} transition={{
          delay: 0.5 + i * 0.1
        }} className="flex items-center gap-4 text-lg text-white/90" data-id="element-226">
              <div className="w-2 h-2 rounded-full bg-[#4fd1c5]" data-id="element-227" />
              {milestone}
            </motion.div>)}
        </div>
      </div>
    </div>;
}